import { iseeInstance } from '../axiosService'

class PatientVUService {
  async fetchPatients (portalName) {
    return iseeInstance.get(`/patients/portal/${portalName}`)
  }

  async addPatient (
    identifier,
    displayName,
    portalName,
    identifierType = 'identifier',
    birthDate = null,
    gender = '',
    additionalInfo = {}
  ) {
    const payload = {
      identifier,
      displayName,
      portal: portalName,
      identifierType
    }

    if (birthDate) {
      payload.birthDate = birthDate
    }

    if (gender) {
      payload.gender = gender
    }

    Object.assign(payload, additionalInfo)

    return iseeInstance.post('/patients', payload)
  }

  async updatePatient (
    patientId,
    identifier,
    displayName,
    portalName,
    identifierType = 'identifier',
    birthDate = null,
    gender = '',
    additionalInfo = {}
  ) {
    const payload = {
      identifier,
      displayName,
      portal: portalName,
      identifierType
    }

    if (birthDate) {
      payload.birthDate = birthDate
    }

    if (gender) {
      payload.gender = gender
    }

    Object.assign(payload, additionalInfo)

    return iseeInstance.put(`/patients/${patientId}`, payload)
  }

  async deletePatient (patientId) {
    return iseeInstance.delete(`/patients/${patientId}`)
  }

  async linkPatientToSession (patientId, sessionId) {
    return iseeInstance.patch('/patients/link-session', {
      patientId,
      sessionId
    })
  }

  async getPatientById (patientId) {
    return iseeInstance.get(`/patients/${patientId}`)
  }

  async getPatientSessions (patientId) {
    return iseeInstance.get(`/patients/${patientId}/sessions`)
  }
}

export default new PatientVUService()
